import React from 'react'
import Header from '../Components/Header/Header'
import SignUpPage from '../Components/Signup/SignUpPage'

function Signup() {
  return (
    <div>
        <Header></Header>
        <SignUpPage></SignUpPage>
    </div>
  )
}

export default Signup